import React from 'react';
import PropTypes from 'prop-types';

export default function UserAuthPage({ children, match: { params } }) {
  return <div>{React.cloneElement(children, { params })}</div>;
}

UserAuthPage.propTypes = {
  children: PropTypes.node.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      reset_password_token: PropTypes.string
    }).isRequired
  }).isRequired
};
